<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
  <div>
    <Head title="Блокировки абонентов" />
    <div class="mb-8 flex max-w-3xl justify-start">
      <h1 class="text-3xl font-bold">Блокировки абонентов</h1>
    </div>

    <div class="mb-8 overflow-hidden rounded bg-white shadow">
      <form @submit.prevent="submitBlock">
        <div class="-mb-8 -mr-6 flex flex-wrap p-8">
          <text-input
            v-model="form.block.account"
            :errors="form.errors.account || []"
            class="w-full pb-8 pr-6"
            label="Абонент"
            placeholder="Введите номер или логин абонента"
          />
          <text-input
            v-model="form.block.reason"
            :errors="form.errors.reason || []"
            class="w-full pb-8 pr-6"
            label="Причина блокировки"
            placeholder="Укажите причину"
          />
        </div>
        <div class="flex items-center border-t border-gray-200 bg-gray-100 px-8 py-4">
          <loading-button
            :loading="form.processing"
            class="btn-danger ml-auto"
            type="submit"
          >
            Заблокировать
          </loading-button>
        </div>
      </form>
    </div>

    <div class="overflow-hidden rounded bg-white shadow">
      <div class="border-b border-gray-200 p-6">
        <form class="flex gap-3" @submit.prevent="applySearch">
          <text-input
            v-model="search"
            class="w-full"
            placeholder="Поиск по абоненту или причине"
          />
          <button class="btn-indigo" type="submit">
            Найти
          </button>
          <button class="btn" type="button" @click="resetSearch">
            Сброс
          </button>
        </form>
      </div>

      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="bg-gray-100 text-left font-bold">
            <th class="px-6 pb-4 pt-5">Абонент</th>
            <th class="px-6 pb-4 pt-5">Причина</th>
            <th class="px-6 pb-4 pt-5 text-right">Действия</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!blocked_accounts.length">
            <td class="border-t px-6 py-4 text-gray-600" colspan="3">
              Ничего не найдено
            </td>
          </tr>
          <tr
            v-for="blockedAccount in blocked_accounts"
            :key="blockedAccount.id"
            class="hover:bg-gray-50 focus-within:bg-gray-50"
          >
            <td class="border-t px-6 py-4">{{ blockedAccount.account }}</td>
            <td class="border-t px-6 py-4">{{ blockedAccount.reason }}</td>
            <td class="border-t px-6 py-4 text-right">
              <button
                class="mr-3 inline-flex items-center"
                type="button"
                title="Редактировать"
                aria-label="Редактировать"
                @click="editBlock(blockedAccount)"
              >
                <icon name="pencil" class="h-4 w-4 fill-indigo-600 hover:fill-indigo-800" />
              </button>
              <button
                class="inline-flex items-center"
                type="button"
                title="Удалить"
                aria-label="Удалить"
                @click="unblock(blockedAccount)"
              >
                <icon name="trash" class="h-4 w-4 fill-red-600 hover:fill-red-800" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="px-6 pb-6">
        <pagination :meta="meta" />
      </div>
    </div>

    <modal
      :open="isEditModalOpen"
      :close-on-backdrop="false"
      title="Редактировать блокировку"
      @close="closeEditModal"
    >
      <div class="bg-white px-8 py-6">
        <div class="flex flex-wrap">
          <text-input
            :disabled="true"
            v-model="editForm.block.account"
            :errors="editForm.errors.account || []"
            class="w-full pb-6"
            label="Абонент"
          />
          <text-input
            v-model="editForm.block.reason"
            :errors="editForm.errors.reason || []"
            class="w-full"
            label="Причина блокировки"
          />
        </div>
      </div>
      <div class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-8 py-4">
        <button class="btn mr-3" type="button" @click="closeEditModal">
          Отмена
        </button>
        <loading-button
          :loading="editForm.processing"
          class="btn-indigo"
          type="button"
          @click="submitEdit"
        >
          Сохранить
        </loading-button>
      </div>
    </modal>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import Icon from '@/Shared/Icon.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import Modal from '@/Shared/Modal.vue';
import Pagination from '@/Shared/Pagination.vue';
import TextInput from '@/Shared/TextInput.vue';

export default {
  components: {
    Head,
    Icon,
    LoadingButton,
    Modal,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    block: {
      type: Object,
      required: true,
    },
    blocked_accounts: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        block: {
          ...this.block,
        },
      }),
      editForm: this.$inertia.form({
        block: {
          id: null,
          account: '',
          reason: '',
        },
      }),
      isEditModalOpen: false,
      search: this.filters.search || '',
    };
  },
  methods: {
    submitBlock() {
      this.form.post('/block', {
        preserveScroll: true,
        onSuccess: () => {
          this.resetForm();
        },
      });
    },
    editBlock(blockedAccount) {
      this.editForm.block = {
        id: blockedAccount.id,
        account: blockedAccount.account,
        reason: blockedAccount.reason,
      };
      this.isEditModalOpen = true;
    },
    closeEditModal() {
      this.isEditModalOpen = false;
      this.editForm.reset();
      this.editForm.clearErrors();
    },
    submitEdit() {
      this.editForm.post('/block', {
        preserveScroll: true,
        onSuccess: () => {
          this.closeEditModal();
        },
      });
    },
    unblock(blockedAccount) {
      if (confirm(`Снять блокировку с ${blockedAccount.account}?`)) {
        this.$inertia.delete(`/block/${blockedAccount.id}`, {
          data: {
            search: this.search,
          },
          preserveState: true,
          preserveScroll: true,
        });
      }
    },
    applySearch() {
      this.$inertia.get(
        '/block',
        { search: this.search },
        {
          preserveState: true,
          preserveScroll: true,
          replace: true,
        },
      );
    },
    resetSearch() {
      this.search = '';
      this.applySearch();
    },
    resetForm() {
      this.form.reset();
      this.form.clearErrors();
    },
  },
};
</script>
